var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 32"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pin_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 4762",
  d: "M0 0h24v32H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 14160",
  clipPath: "url(#pin_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 12914",
  d: "M12 32a1.961 1.961 0 0 1-1.211-.417C8.511 29.806 0 21.277 0 12.015a12 12 0 1 1 24 0c0 9.261-8.509 17.79-10.789 19.567A1.961 1.961 0 0 1 12 32m-.43-2.52ZM12 2.667a9.352 9.352 0 0 0-9.333 9.349c0 7.593 6.877 14.971 9.333 17.109 2.457-2.138 9.333-9.516 9.333-17.109A9.352 9.352 0 0 0 12 2.667"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 12915",
  d: "M12 18.174a5.667 5.667 0 1 1 5.667-5.667A5.673 5.673 0 0 1 12 18.174m0-8.667a3 3 0 1 0 3 3 3 3 0 0 0-3-3"
}))));
export default SvgPin;